import {EnvUtils} from "../utils/env-utils";

export class TwitchConfig {
    public static readonly openIdProvider = EnvUtils.readString('REACT_APP_TWITCH_OPENID_PROVIDER');
}
